module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加产品")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.delGoods
    }
  }, [_vm._v("批量刪除")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportloading),
      expression: "exportloading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tagsList,
      "height": _vm.wheight - 130
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "reserve-selection": true,
      "align": "center",
      "label": "全选"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.name) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "商品类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '1') ? _c('span', [_vm._v("现金")]) : _vm._e(), _vm._v(" "), (scope.row.type == '2') ? _c('span', [_vm._v("优惠券")]) : _vm._e(), _vm._v(" "), (scope.row.type == '3') ? _c('span', [_vm._v("实物")]) : _vm._e(), _vm._v(" "), (scope.row.type == '4') ? _c('span', [_vm._v("积分大转盘")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_online",
      "label": "优惠券类型",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_online == '1') ? _c('span', [_vm._v("线上优惠券")]) : _vm._e(), _vm._v(" "), (scope.row.is_online == '2') ? _c('span', [_vm._v("线下优惠券")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "points",
      "label": "积分价格",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.points) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "card_id",
      "label": "卡券ID/策略ID",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.card_id) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "material_goods_id",
      "label": "实物ID",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.material_goods_id) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pics",
      "label": "商品图片",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticStyle: {
            "width": "100px",
            "height": "60px"
          },
          attrs: {
            "src": scope.row.pics,
            "mode": "modeWidth"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "创建时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n      " + _vm._s(scope.row.create_time) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_pay",
      "label": "是否在售",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_pay == '1') ? _c('span', [_vm._v("在售")]) : _vm._e(), _vm._v(" "), (scope.row.is_pay == '2') ? _c('span', [_vm._v("不在售")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑标签",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品名称"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入商品名称"
      },
      model: {
        value: (_vm.form.name),
        callback: function($$v) {
          _vm.$set(_vm.form, "name", $$v)
        },
        expression: "form.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品积分"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入商品积分值"
      },
      model: {
        value: (_vm.form.points),
        callback: function($$v) {
          _vm.$set(_vm.form, "points", $$v)
        },
        expression: "form.points"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "兑换次数"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入商品兑换次数,无数填0"
      },
      model: {
        value: (_vm.form.exchange_count),
        callback: function($$v) {
          _vm.$set(_vm.form, "exchange_count", $$v)
        },
        expression: "form.exchange_count"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "每天允许兑换最大次数"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入每天允许兑换最大次数,无数填0"
      },
      model: {
        value: (_vm.form.max_day_exchange_count),
        callback: function($$v) {
          _vm.$set(_vm.form, "max_day_exchange_count", $$v)
        },
        expression: "form.max_day_exchange_count"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品类型"
      }
    }, [
      [_c('el-radio-group', {
        on: {
          "change": _vm.type_change
        },
        model: {
          value: (_vm.form.type),
          callback: function($$v) {
            _vm.$set(_vm.form, "type", $$v)
          },
          expression: "form.type"
        }
      }, [_c('el-radio-button', {
        attrs: {
          "label": "1"
        }
      }, [_vm._v("现金")]), _vm._v(" "), _c('el-radio-button', {
        attrs: {
          "label": "2"
        }
      }, [_vm._v("优惠券")]), _vm._v(" "), _c('el-radio-button', {
        attrs: {
          "label": "3"
        }
      }, [_vm._v("实物")])], 1)]
    ], 2), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品详细分类"
      }
    }, [
      [
        [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.form.category_id),
            callback: function($$v) {
              _vm.$set(_vm.form, "category_id", $$v)
            },
            expression: "form.category_id"
          }
        }, _vm._l((_vm.cateGoryList), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)]
      ]
    ], 2), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "卡券ID/策略ID"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "仅限优惠券可填"
      },
      model: {
        value: (_vm.form.card_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "card_id", $$v)
        },
        expression: "form.card_id"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "线上线下"
      }
    }, [
      [_c('el-radio-group', {
        model: {
          value: (_vm.form.is_online),
          callback: function($$v) {
            _vm.$set(_vm.form, "is_online", $$v)
          },
          expression: "form.is_online"
        }
      }, [_c('el-radio-button', {
        attrs: {
          "label": "1"
        }
      }, [_vm._v("线上")]), _vm._v(" "), _c('el-radio-button', {
        attrs: {
          "label": "2"
        }
      }, [_vm._v("线下")])], 1)]
    ], 2), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品ID"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "仅限实物可填"
      },
      model: {
        value: (_vm.form.material_goods_id),
        callback: function($$v) {
          _vm.$set(_vm.form, "material_goods_id", $$v)
        },
        expression: "form.material_goods_id"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "是否在售"
      }
    }, [
      [_c('el-radio-group', {
        model: {
          value: (_vm.form.is_pay),
          callback: function($$v) {
            _vm.$set(_vm.form, "is_pay", $$v)
          },
          expression: "form.is_pay"
        }
      }, [_c('el-radio-button', {
        attrs: {
          "label": "1"
        }
      }, [_vm._v("在售")]), _vm._v(" "), _c('el-radio-button', {
        attrs: {
          "label": "2"
        }
      }, [_vm._v("不在售")])], 1)]
    ], 2), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "兑换次数说明"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "placeholder": "请输入内容"
      },
      model: {
        value: (_vm.form.point_frequency),
        callback: function($$v) {
          _vm.$set(_vm.form, "point_frequency", $$v)
        },
        expression: "form.point_frequency"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "兑换须知"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "placeholder": "请输入内容"
      },
      model: {
        value: (_vm.form.exchange_instructions),
        callback: function($$v) {
          _vm.$set(_vm.form, "exchange_instructions", $$v)
        },
        expression: "form.exchange_instructions"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品详情"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "placeholder": "请输入内容"
      },
      model: {
        value: (_vm.form.intro),
        callback: function($$v) {
          _vm.$set(_vm.form, "intro", $$v)
        },
        expression: "form.intro"
      }
    })], 1), _vm._v(" "), _c('el-upload', {
      staticClass: "upload-demo",
      attrs: {
        "multiple": true,
        "action": _vm.actionPath,
        "accept": "image/jpeg,image/png,image/gif",
        "show-file-list": false,
        "data": _vm.postData,
        "before-upload": _vm.beforeAvatarUpload,
        "on-success": _vm.handleAvatarSuccess
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("本地上传")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("只能上传jpg/png文件，且不超过2M")])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveTagData
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f0debc2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f0debc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/duiba/goods/list.vue
// module id = 2469
// module chunks = 0